import "./libs/slick";
import "./libs/infiniteslidev2";

import {binder} from "./libs/binder";
import {constants} from "./modules/module";
import {fullHeightPage} from "./modules/fullHeightPage";
import {stickyHeader} from "./modules/stickyHeader";
import {mobileNav} from "./modules/mobileNav";
import {announcementBar} from "./modules/announcementBar";
import {parallax} from "./modules/parallax";
import {animationOnScroll} from "./modules/animationOnScroll";
import {newsListSlider} from "./modules/newsListSlider";
import {textAnimation} from "./modules/textAnimation";
import {popups} from "./modules/popups";
import {featuredPostSlider} from "./modules/featuredPostSlider";
import {copyLinkToBuffer} from "./modules/copyLinkToBuffer";
import {worksStickyNav} from "./modules/worksStickyNav";
import {anchors} from "./modules/anchors";
import {accordion} from "./modules/accordion";
import {winLocatioHash} from "./modules/winLocatioHash";
import {countersAnimation} from "./modules/countersAnimation";
import {articleQuoteSlider} from "./modules/articleQuoteSlider";
import {logosSlider} from "./modules/logosSlider";
import {partnersSlider} from "./modules/partnersSlider";
import {timelineSlider} from "./modules/timelineSlider";
import {worksArea} from "./modules/worksArea";


binder({
    bounds: {
        html: [constants, fullHeightPage, announcementBar, winLocatioHash],
        ".header": [stickyHeader, mobileNav],
        ".has-parallax": parallax,
        ".has-animation": animationOnScroll,
        ".news-list.slider-on-mobile": newsListSlider,
        ".text-animation": textAnimation,
        ".popup-link": popups,
        ".featured-post-slider": featuredPostSlider,
        ".copy-link": copyLinkToBuffer,
        ".our-works": worksStickyNav,
        ".has-anchor": anchors,
        ".accordion, .our-work-accordion": accordion,
        ".has-counters-animation": countersAnimation,
        ".article-quote-slider": articleQuoteSlider,
        ".logos-slider": logosSlider,
        ".partners-slider": partnersSlider,
        ".timeline-slider": timelineSlider,
        ".works-area": worksArea
    },
    runTests: false
});




// WEBPACK FOOTER //
// ./assets/js/global.js